// mmenu
document.addEventListener(
    "DOMContentLoaded", () => {

        const menu = new Mmenu("#mobile-nav", {
            "extensions": [
                "position-right"
            ]
        }, {
        });

        const api = menu.API;

        document.querySelector( "#mobile-menu-toggle" )
            .addEventListener(
                "click", ( evnt ) => {
                    evnt.preventDefault();
                    api.open();
                }
            );
    }
);

